/* Scroll reveal. Reveals instantly in the theme editor so re-rendered
   sections never stay invisible, and re-runs when a section reloads. */
(function () {
  var instant =
    !('IntersectionObserver' in window) ||
    window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
    (window.Shopify && window.Shopify.designMode);

  function reveal(root) {
    var items = (root || document).querySelectorAll('.rv:not(.in)');
    if (!items.length) return;

    if (instant) {
      for (var i = 0; i < items.length; i++) items[i].classList.add('in');
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });

    for (var j = 0; j < items.length; j++) io.observe(items[j]);
  }

  reveal();
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
  document.addEventListener('shopify:block:select', function (e) { reveal(e.target); });
})();
